import { GraphQLFormattedError } from 'graphql';
import _ from 'lodash';

export const parseGraphqlErrors = (graphQLErrors?: readonly GraphQLFormattedError[]): string => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const e = graphQLErrors as any;
  const catchError = _.get(e, 'networkError.result.errors.0.message');
  // Apollo Server 5 nests the ValidationPipe output under originalError;
  // Apollo 3 put it under exception.response. Accept both.
  const inputError =
    _.get(e, '0.extensions.originalError.message.0') ||
    _.get(e, '0.extensions.exception.response.message.0');
  let error;
  if (Array.isArray(_.get(e, '0.extensions.response.message.0'))) {
    error = _.get(e, '0.extensions.response.message.0');
  }
  const message = _.get(e, 'message');
  const bagError = _.get(e, '0.message');
  return catchError || inputError || error || bagError || message;
};
